import "./CSS/full-screen-popup.scss";
import React, { useEffect, useState } from "react";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useNoScroll } from "../../hooks";

const PokerFullScreenPopupWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5000;
  pointer-events: none;
`;

const PokerFullScreenPopup = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const [isScrollDisabled, setIsScrollDisabled] = useState(false);
  const fullScreenContainer = document.getElementById("uc-full-screen-popup");

  useEffect(() => {
    let observer;
    const toggleClassBasedOnContent = () => {
      const hasContent = fullScreenContainer.childNodes.length > 0;
      setIsScrollDisabled(hasContent);
    };
    if (fullScreenContainer && isMobile) {
      toggleClassBasedOnContent();
      observer = new MutationObserver(toggleClassBasedOnContent);
      observer.observe(fullScreenContainer, { childList: true, subtree: true });
    }
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [fullScreenContainer, isMobile]);

  useNoScroll("uc-full-screen-popup", isScrollDisabled);

  return <PokerFullScreenPopupWrapper id="uc-full-screen-popup" />;
};

export default PokerFullScreenPopup;
